import React, { useState } from "react";

const API = process.env.REACT_APP_MAIL_API;

export default function MailerControlPage() {
  const [loading, setLoading] = useState(null);
  const [result, setResult] = useState(null);
  const [weekStart, setWeekStart] = useState("");
const [weekEnd, setWeekEnd] = useState("");

  const trigger = async (type, body = null) => {
    try {
      setLoading(type);
      setResult(null);

      const res = await fetch(`${API}/${type}`, {
        method: "POST",
        headers: body ? { "Content-Type": "application/json" } : {},
        body: body ? JSON.stringify(body) : null
      });

      const data = await res.json();
      setResult({ type, data });

    } catch (err) {
      setResult({ type, error: err.message });
    } finally {
      setLoading(null);
    }
  };

  const cards = [
    {
      title: "HOD Mails",
      desc: "Send pending correction approvals to HODs",
      api: "send-hod-mails",
      color: "#2563eb"
    },
    {
      title: "Doer Mails",
      desc: "Send decision updates to doers",
      api: "send-doer-mails",
      color: "#16a34a"
    },
    {
      title: "Performance Mails",
      desc: "Send weekly performance report",
      api: "send-performance-mails",
      body: null,
      color: "#9333ea"
    },
    {
      title: "Commitment Mails",
      desc: "Send commitment request mails",
      api: "send-commitment-mails",
      color: "#dc2626"
    }
  ];

  return (
    <div style={{ padding: 20 }}>

      {/* Header */}
      <div style={{
        marginBottom: 20,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <h2 style={{ fontWeight: 900, color: "#26428b" }}>
          📬 Mailer Control Panel
        </h2>
      </div>

      <div style={{
  display: "flex",
  gap: 12,
  marginBottom: 20,
  flexWrap: "wrap"
}}>

  <div>
    <label style={{ fontSize: 12 }}>Start Date</label><br />
    <input
      type="date"
      value={weekStart}
      onChange={(e) => setWeekStart(e.target.value)}
      style={{
        padding: 8,
        borderRadius: 6,
        border: "1px solid #ccc"
      }}
    />
  </div>

  <div>
    <label style={{ fontSize: 12 }}>End Date</label><br />
    <input
      type="date"
      value={weekEnd}
      onChange={(e) => setWeekEnd(e.target.value)}
      style={{
        padding: 8,
        borderRadius: 6,
        border: "1px solid #ccc"
      }}
    />
  </div>

</div>

      {/* Cards */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
        gap: 16
      }}>

        {cards.map((card, i) => (
          <div key={i} style={{
            background: "#fff",
            borderRadius: 14,
            padding: 16,
            border: "1px solid rgba(0,0,0,0.08)",
            boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
          }}>

            <div>
              <div style={{
                fontSize: 18,
                fontWeight: 800,
                marginBottom: 6
              }}>
                {card.title}
              </div>

              <div style={{
                fontSize: 13,
                color: "#64748b",
                marginBottom: 12
              }}>
                {card.desc}
              </div>
            </div>

<button
  onClick={() => {
    if (card.api === "send-performance-mails") {
      if (!weekStart || !weekEnd) {
        alert("Please select Start & End Date");
        return;
      }

      trigger(card.api, {
        weekStart,
        weekEnd
      });
    } else {
      trigger(card.api, card.body);
    }
  }}
              disabled={loading === card.api}
              style={{
                padding: "10px 12px",
                borderRadius: 8,
                border: "none",
                background: card.color,
                color: "#fff",
                fontWeight: 700,
                cursor: "pointer",
                opacity: loading === card.api ? 0.6 : 1
              }}
            >
              {loading === card.api ? "Running..." : "Run"}
            </button>

          </div>
        ))}

      </div>

      {/* Loader */}
      {loading && (
        <div style={{
          marginTop: 20,
          padding: 10,
          background: "#f1f5f9",
          borderRadius: 8,
          fontSize: 14
        }}>
          ⏳ Running <b>{loading}</b>...
        </div>
      )}

      {/* Result */}
      {result && (
        <div style={{
          marginTop: 20,
          background: "#0f172a",
          color: "#e2e8f0",
          padding: 14,
          borderRadius: 10,
          fontSize: 12,
          overflow: "auto"
        }}>
          <b style={{ color: "#38bdf8" }}>{result.type}</b>
          <pre style={{ marginTop: 10 }}>
            {JSON.stringify(result.data || result.error, null, 2)}
          </pre>
        </div>
      )}

    </div>
  );
}